import Button from 'ui/Button/Button';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import './Token.scss';

const Token: React.FC = (props) => {
  return (
    <div className="token" id="token">
      <div className="token__backgrounds">
        <div>
          <img src={require('images/token/portal.png')} alt="portal" />
          <img src={require('images/token/portal-2.png')} alt="portal" />
          <img src={require('images/token/portal-3.png')} alt="portal" />
          <img src={require('images/token/portal-4.png')} alt="portal" />
        </div>
      </div>
      <div className="container token__container">
        <ContentFrame title="Token" className="token__frame">
          <div className="token__content">
            <div className="token__wrapper">
              <img src={require('images/token/logos.png')} alt="logos" className="token__logos" />
              <SectionTitle className="token__title">
                <span>$gsp token</span>
              </SectionTitle>
              <p className="token__text">
                As an essential part of the Arcader ecosystem, the token is the governance
                token of the ecosystem and will be powered by the collective power of the
                people.
              </p>
            </div>
            <Button title="Start" to="#" className="token__btn" />
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Token;
